module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-4-m1.1fea9701.jpg";